import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    flexDirection: 'column',
  },
  list: {
    overflow: 'hidden',
    width: '100%',
    height: '100%',
  },
  listInner: {
    'overflow-y': 'scroll',
    height: '100%',
  },
  box: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  emptyStateContainer: {
    flexGrow: 1,
  },
}));

export default useStyles;
